import { Card } from "antd";
import React from "react";
import { ANNOUNCEMENT_COLOR_OPTIONS, TIME_FORMAT_12HM } from "variables/constants";
import { displayIcon } from "variables/icons";
import dayjs from "dayjs";

const AnnouncementCard = ({ announcement, isSelected, onRemove, selectedId }) => {
  
    const selectedColor = ANNOUNCEMENT_COLOR_OPTIONS.find(
      (color) => color.value === announcement?.ann_color_class
    );

  return (
    <Card
      className={`
        group rounded-2xl overflow-hidden transform transition-all duration-300 ease-in-out hover:shadow-2xl dark:border-none
        ${selectedColor?.gradient || ""}
        ${isSelected ? "opacity-100 translate-y-0 z-10" : "opacity-10 translate-y-4 z-0 pointer-events-none"}
      `}
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-64 h-64 bg-white rounded-full -mr-32 -mt-32 opacity-10"></div>
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-white rounded-full -ml-24 -mb-24 opacity-10"></div>
      </div>

      <button
        className="absolute top-4 right-4 flex z-50 items-center justify-center p-1.5 rounded-xl bg-white/20 hover:bg-white/30 backdrop-blur-sm transition-all"
        // onClick={(e) => {
        //   e.stopPropagation();
        //   onRemove(selectedId);
        // }}
      >
        {displayIcon("X", "w-3.5 h-3.5 pointer-events-none text-white" )}
      </button>

      <div className="relative z-10 flex flex-col md:flex-row gap-6 items-start">
        <div className="flex-shrink-0">
          <div className="w-16 h-16 rounded-2xl bg-white/20 backdrop-blur-sm flex items-center justify-center shadow-lg group-hover:scale-110  duration-300 ">
            {displayIcon(announcement?.ann_icon, "w-8 h-8 text-white" )}
          </div>
        </div>

        <div className="flex-1 text-white">
          <div className="flex items-start justify-between gap-4 mb-3">
            <div>
              <div className="flex items-center gap-2 mb-2">
                <span className="inline-flex items-center justify-center rounded-lg border px-2 py-0.5 font-medium text-[10px] uppercase tracking-wider bg-white/20 border-white/30 text-white">
                  {announcement?.category_name}
                </span>
                  {announcement?.priority_level === "High" && (
                    <span className={`flex items-center gap-1 justify-center rounded-md px-2 py-0.5 font-medium text-[10px] bg-red-500 text-white`}>
                        <>
                          {displayIcon("AlertTriangle", "w-3 h-3 text-white" )} URGENT
                        </>
                    </span>
                  )}
              </div>
              <h3 className="text-2xl mb-2 font-semibold">{announcement?.ann_title}</h3>
            </div>
          </div>

          <p className="text-white/90 text-[15px] leading-relaxed mb-4 font-normal">{announcement?.ann_description}</p>

          <div className="flex flex-wrap items-center gap-4 text-sm">
            {announcement?.ann_event_date_from && (
              <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-3 py-1.5 rounded-lg">
                {displayIcon("Calendar", "w-4 h-4" )}

                <span className="font-medium">
                  {dayjs(announcement.ann_event_date_from).format("MMM D, YYYY")}
                    {announcement?.ann_event_date_to && ` - ${dayjs(announcement.ann_event_date_to).format("MMM D, YYYY")}`}
                </span>
              </div>
            )}
            {announcement?.ann_event_time_from && (
              <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-3 py-1.5 rounded-lg">
                {displayIcon("Clock", "w-4 h-4" )}
                  <span>
                    {dayjs(
                      announcement.ann_event_time_from,
                      ["HH:mm:ss", "HH:mm"]
                    ).format(TIME_FORMAT_12HM)}

                    {announcement?.ann_event_time_to &&
                      ` - ${dayjs(
                        announcement.ann_event_time_to,
                        [ "HH:mm"]
                      ).format(TIME_FORMAT_12HM)}`}
                  </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </Card>
  );
};

export default AnnouncementCard;
